// SAT Akademie — bilingual content (DE / EN)
export const translations = {
  de: {
    nav: {
      start: "Start Here",
      themen: "Themen",
      angebote: "Angebote",
      ueber: "Über Nenad",
      ecosystem: "Ökosystem",
      community: "Community",
      kontakt: "Kontakt",
      quiz: "SAT-Test",
      lebensrad: "Lebensrad",
      cta: "Erstgespräch",
    },
    hero: {
      kicker: "Schweizer Akademie für Transformation",
      title_1: "Die",
      title_2: "Spielregeln",
      title_3: "des Lebens.",
      title_caps: "DIE SPIELREGELN DES LEBENS",
      subtitle_l1: "Verstehe dich selbst.",
      subtitle_l2: "Stärke deine Beziehungen.",
      subtitle_l3: "Entfalte dein volles Potenzial.",
      subtitle: "Verstehe dich selbst. Stärke deine Beziehungen. Entfalte dein volles Potenzial.",
      whisper: "Die wichtigsten Spielregeln des Lebens wurden uns nie beigebracht.",
      cta_primary: "Jetzt den ersten Schritt gehen",
      cta_secondary: "Kostenloses Erstgespräch",
      stats: [
        { k: "10+", v: "Jahre Mentoring" },
        { k: "1'200+", v: "begleitete Menschen" },
        { k: "9", v: "Spielregeln des Lebens" },
      ],
    },
    problem: {
      overline: "Das Leiden hat ein Muster",
      title: "Warum fühlen sich Menschen — trotz allem — leer?",
      paragraph:
        "Wir lernen Mathematik. Wir lernen Sprachen. Wir lernen Berufe. Doch niemand hat uns je beigebracht, wie man liebt, wie man Konflikte hält, wie man Selbstwert nährt, wie man Sinn findet — und wie man aus Mustern aussteigt, die seit Generationen weitergegeben werden.",
      cards: [
        { t: "Beziehungen scheitern", d: "Obwohl Liebe da ist." },
        { t: "Erfolg fühlt sich leer an", d: "Obwohl du alles erreicht hast." },
        { t: "Dieselben Muster", d: "Obwohl du es anders willst." },
        { t: "Sinnsuche im Lärm", d: "Obwohl du eine Antwort spürst." },
      ],
    },
    solution: {
      overline: "Die SAT-Methode",
      title: "Vier Schritte. Eine Transformation.",
      steps: [
        { n: "01", t: "Problem", d: "Wir benennen, was wirklich schmerzt — ohne Beschönigung." },
        { n: "02", t: "Erkenntnis", d: "Wir machen unbewusste Muster, Prägungen und Glaubenssätze sichtbar." },
        { n: "03", t: "Transformation", d: "Du wählst neu. Auf Ebene des Bewusstseins, des Körpers und der Beziehungen." },
        { n: "04", t: "Freiheit", d: "Du lebst aus deiner Wahrheit — getragen von Liebe statt Angst." },
      ],
    },
    starthere: {
      overline: "Start Here",
      title: "Beginne mit dem SAT-Test.",
      subtitle:
        "In wenigen Minuten findest du heraus, welche Spielregel des Lebens dich gerade am meisten ruft. Wir führen dich danach in die für dich passende SAT-Welt.",
      cta: "SAT-Test starten",
      cta_secondary: "Lebensrad ausfüllen",
    },
    mentor: {
      overline: "Über den Gründer",
      name: "Nenad Vladovic",
      role: "Mentor · Lebensdesigner · Bewusstseinsforscher",
      tagline:
        "Ich helfe Menschen dabei, die Spielregeln des Lebens zu verstehen — damit Beziehungen gelingen, Selbstvertrauen wächst und echte Transformation möglich wird.",
      story: [
        "Mein Weg begann nicht mit Antworten. Er begann mit Fragen.",
        "Warum leiden Menschen? Warum wiederholen sich dieselben Konflikte immer wieder? Warum scheitern Beziehungen, obwohl Liebe vorhanden ist? Warum fühlen sich viele Menschen trotz Erfolg innerlich leer? Und weshalb hat uns niemand die wichtigsten Spielregeln des Lebens beigebracht?",
        "Auf meiner eigenen Reise durfte ich erfahren, wie stark unser Leben von unbewussten Prägungen, Glaubenssätzen, Ängsten, Verletzungen und inneren Konflikten beeinflusst wird. Gleichzeitig erkannte ich, welches enorme Potenzial in jedem Menschen steckt, wenn er beginnt, sich selbst wirklich zu verstehen.",
        "Aus dieser Erkenntnis entstand die SAT — Schweizer Akademie für Transformation.",
      ],
      mission_title: "Meine Mission",
      mission:
        "Menschen dabei zu unterstützen, sich selbst besser zu verstehen, bewusster zu leben und ihr Potenzial zu entfalten. Viele Probleme entstehen nicht deshalb, weil Menschen zu wenig Fähigkeiten besitzen — sondern weil ihnen die wichtigsten Spielregeln des Lebens fehlen.",
      values_title: "Wofür ich stehe",
      values: [
        "Entwicklung statt Verurteilung",
        "Bewusstsein statt Schuldzuweisung",
        "Verantwortung statt Opferrolle",
        "Mitgefühl statt Trennung",
        "Liebe als grösste Transformationskraft",
      ],
      vision_title: "Die Vision der SAT",
      vision:
        "Eine der bedeutendsten Plattformen für Transformation, Lebenskompetenz und Bewusstseinsentwicklung im deutschsprachigen Raum aufzubauen. Eine Plattform, die Orientierung gibt, Hoffnung vermittelt und Menschen verbindet.",
      motto: "LOVE IS TRANSFORMATION",
      motto_sub: "Jede echte Veränderung beginnt dort, wo wir den Mut finden, uns selbst ehrlich zu begegnen.",
    },
    themes: {
      overline: "Unsere Themen",
      title: "Neun Räume. Ein Weg zu dir.",
      subtitle: "Wähle den Raum, der dich gerade ruft. Wir begleiten dich in die Tiefe.",
      items: [
        { t: "Beziehungen", d: "Verbinden statt verstricken." },
        { t: "Selbstwert", d: "Sich selbst als wertvoll annehmen." },
        { t: "Berufung", d: "Tun, was deinem Wesen entspricht." },
        { t: "Trauma", d: "Heilen, was du nicht wählen konntest." },
        { t: "Kommunikation", d: "Sagen, was wirklich gemeint ist." },
        { t: "Human Design", d: "Erkennen, wer du bist." },
        { t: "Bewusstsein", d: "Hinter die Reaktion schauen." },
        { t: "Familie", d: "Wurzeln heilen, Stamm stärken." },
        { t: "Sinnfindung", d: "Orientierung im Lärm finden." },
      ],
    },
    offerings: {
      overline: "Angebote",
      title: "Begleitung auf jeder Stufe.",
      items: [
        { t: "SAT Coaching", d: "1:1 Mentoring — online oder vor Ort.", price: "Auf Anfrage" },
        { t: "SAT Academy", d: "Geführte Online-Kurse & Module zu den Spielregeln des Lebens.", price: "Ab CHF 49" },
        { t: "Herzbewegung", d: "Community-Initiative für gelebte Menschlichkeit.", price: "Kostenlos beitreten" },
        { t: "Workshops", d: "Intensive Tage in der Gruppe — Schweiz & DACH.", price: "Ab CHF 290" },
        { t: "Seminare & Retreats", d: "Mehrtägige Transformationserlebnisse.", price: "Ab CHF 890" },
        { t: "Bücher & Audiobooks", d: "Die Spielregeln des Lebens — schwarz auf weiß.", price: "Ab CHF 24" },
      ],
      cta: "Programm auf mich zuschneiden",
    },
    testimonials: {
      overline: "Stimmen aus der SAT",
      title: "Was Menschen sagen, die den ersten Schritt gegangen sind.",
      items: [
        {
          q: "Die SAT-Unity-Gemeinschaft hilft mir dabei, an meinen Themen dran zu bleiben. Ich lerne stetig dazu und freue mich jede Woche auf den Austausch.",
          a: "Sandra Gross",
          l: "Schwamendingen, CH",
        },
        {
          q: "Es ist schön zu sehen, dass hier auf ein respektvolles Miteinander geachtet wird — das gibt einem ein gutes Gefühl als Mitglied.",
          a: "Uwe Tännler",
          l: "Brienz, CH",
        },
        {
          q: "Solche klaren Werte schaffen eine angenehme Atmosphäre und machen die Community zu einem Ort, an dem man sich wohlfühlen kann.",
          a: "Gunnar Kloss",
          l: "Hamburg, DE",
        },
        {
          q: "Nenad hat mir geholfen, einen Konflikt zu sehen, den ich seit Jahren mit mir trug. Heute fühlt sich mein Leben weiter an.",
          a: "Vanessa B.",
          l: "Zürich, CH",
        },
      ],
    },
    community: {
      overline: "Herzbewegung",
      title: "Eine Bewegung, die das Herz berührt.",
      subtitle:
        "Herzbewegung ist die gemeinnützige Initiative der SAT. Jeden Tag eine kleine Geste, die das Leben eines anderen Menschen heller macht. Aus Hunderten von Gesten entsteht eine Welle.",
      points: ["Community Challenges", "Good-News-Bereich", "Erfolgsgeschichten", "Live Events"],
      cta: "Mitmachen",
    },
    ecosystem: {
      overline: "Das SAT-Ökosystem",
      title: "Eine Akademie. Viele Welten.",
      subtitle: "Wähle die Welt, die dich ruft. Jede Plattform ist Teil derselben Mission.",
      items: [
        { k: "akademie", t: "SAT Akademie", d: "Hauptmarke · Persönlichkeitsentwicklung & Bewusstsein.", tag: "Hauptmarke" },
        { k: "herzbewegung", t: "Herzbewegung", d: "Community für tägliche Menschlichkeit.", tag: "Initiative" },
        { k: "vaterstimme", t: "Vaterstimme", d: "Selbstermächtigung zur Vaterschaft in Würde.", tag: "Männer · Väter" },
        { k: "mutterstimme", t: "Mutterstimme", d: "Selbstfürsorge, Balance & Mutterschaft.", tag: "Frauen · Mütter" },
        { k: "maennerstimme", t: "Männerstimme", d: "Bewusste Männlichkeit & Entwicklung.", tag: "Männer" },
        { k: "frauenstimme", t: "Frauenstimme", d: "Persönlichkeitsentwicklung für Frauen.", tag: "Frauen" },
        { k: "kinderstimme", t: "Kinderstimme", d: "Kinder- und Familienentwicklung.", tag: "Familie" },
        { k: "mentor", t: "SAT Mentor Academy", d: "Ausbildung zum SAT Mentor, Coach, Trainer, Speaker.", tag: "Ausbildung" },
        { k: "corporate", t: "Corporate Conscious Leadership", d: "Bewusste Führung für Unternehmen & KMU.", tag: "Business" },
        { k: "book", t: "SAT BOOK", d: "Bücher, Arbeitsbücher, Audiobooks, Downloads.", tag: "Media" },
        { k: "podcast", t: "SAT Podcast", d: "Die Spielregeln des Lebens — zum Hören.", tag: "Audio" },
        { k: "tv", t: "SAT TV", d: "Video-Lernplattform. Mediathek. Dokumentationen.", tag: "Video" },
        { k: "app", t: "SAT App", d: "Deine tägliche Begleitung — bald in deiner Tasche.", tag: "Mobile" },
        { k: "ai", t: "SAT AI", d: "Bewusster KI-Coach im SAT-Spirit — in Entwicklung.", tag: "Intelligence" },
      ],
      coming: "Bald verfügbar",
    },
    leadmagnet: {
      overline: "Kostenlose Ressourcen",
      title: "Workbook · 9 Schritte zu deiner Transformation",
      subtitle:
        "Trage deine E-Mail ein und erhalte dein kostenloses Workbook — plus eine inspirierende Impuls-Reise aus der SAT-Welt.",
      placeholder_name: "Vorname",
      placeholder_email: "E-Mail Adresse",
      cta: "Workbook erhalten",
      success: "Willkommen in der SAT-Familie. Schau in dein Postfach.",
      privacy: "Wir respektieren deine Privatsphäre. Du kannst dich jederzeit abmelden.",
    },
    finalcta: {
      title_l1: "Vielleicht ist heute",
      title_l2: "der Tag, an dem",
      title_l3: "sich dein Leben verändert.",
      cta: "Kostenloses Gespräch buchen",
      whisper: "LOVE IS TRANSFORMATION",
    },
    contact: {
      title: "Kontaktiere uns",
      subtitle: "Schreib uns, was dich beschäftigt. Wir melden uns persönlich.",
      first_name: "Vorname",
      last_name: "Name",
      email: "E-Mail",
      phone: "Telefon (optional)",
      topic: "Thema",
      topic_options: ["Erstgespräch", "Coaching", "Academy", "Corporate", "Anderes"],
      message: "Deine Nachricht",
      send: "Absenden",
      success: "Danke! Deine Nachricht ist angekommen.",
    },
    quiz: {
      title: "Welche Spielregel des Lebens fehlt dir aktuell?",
      subtitle: "12 Fragen · 3 Minuten · Persönliche Auswertung per E-Mail.",
      start: "Test starten",
      progress: "Frage",
      of: "von",
      scale_low: "trifft gar nicht zu",
      scale_high: "trifft voll zu",
      email_step_title: "Dein Ergebnis ist bereit.",
      email_step_sub: "Hinterlasse deine E-Mail — wir senden dir die persönliche Auswertung sofort zu.",
      submit: "Ergebnis ansehen",
      result_kicker: "Deine fehlende Spielregel",
      result_cta: "Kostenloses Erstgespräch buchen",
      another: "Test erneut machen",
    },
    wheel: {
      title: "Dein Lebensrad",
      subtitle: "Bewerte jeden Bereich von 0 bis 10. Sieh, wo dein Leben rund läuft — und wo es ruckelt.",
      categories: {
        beziehung: "Beziehung",
        gesundheit: "Gesundheit",
        beruf: "Beruf",
        finanzen: "Finanzen",
        familie: "Familie",
        sinn: "Sinn",
        selbstwert: "Selbstwert",
        spiritualitaet: "Spiritualität",
      },
      save: "Ergebnis speichern",
      avg: "Durchschnitt",
      weakest: "Dein Wachstumsbereich",
    },
    footer: {
      tagline: "Schweizer Akademie für Transformation",
      motto: "LOVE IS TRANSFORMATION",
      col1: "Akademie",
      col2: "Ökosystem",
      col3: "Mehr",
      rights: "Alle Rechte vorbehalten.",
      imprint: "Impressum",
      privacy: "Datenschutz",
      terms: "AGB",
    },
  },
  en: {
    nav: {
      start: "Start Here",
      themen: "Topics",
      angebote: "Offerings",
      ueber: "About Nenad",
      ecosystem: "Ecosystem",
      community: "Community",
      kontakt: "Contact",
      quiz: "SAT-Test",
      lebensrad: "Wheel of Life",
      cta: "Free Talk",
    },
    hero: {
      kicker: "Swiss Academy for Transformation",
      title_1: "The",
      title_2: "Rules",
      title_3: "of Life.",
      title_caps: "THE RULES OF LIFE",
      subtitle_l1: "Understand yourself.",
      subtitle_l2: "Strengthen your relationships.",
      subtitle_l3: "Unfold your full potential.",
      subtitle: "Understand yourself. Strengthen your relationships. Unfold your full potential.",
      whisper: "The most important rules of life were never taught to us.",
      cta_primary: "Take the first step now",
      cta_secondary: "Free first conversation",
      stats: [
        { k: "10+", v: "years of mentoring" },
        { k: "1,200+", v: "humans accompanied" },
        { k: "9", v: "rules of life" },
      ],
    },
    problem: {
      overline: "Suffering has a pattern",
      title: "Why do people — despite everything — feel empty?",
      paragraph:
        "We learn maths. We learn languages. We learn professions. Yet nobody ever taught us how to love, how to hold conflict, how to nourish self-worth, how to find meaning — and how to step out of patterns that have been passed on for generations.",
      cards: [
        { t: "Relationships fail", d: "Even though love is there." },
        { t: "Success feels empty", d: "Even though you achieved it all." },
        { t: "The same patterns", d: "Even though you want different." },
        { t: "Searching for meaning", d: "Even though you sense an answer." },
      ],
    },
    solution: {
      overline: "The SAT method",
      title: "Four steps. One transformation.",
      steps: [
        { n: "01", t: "Problem", d: "We name what truly hurts — without softening." },
        { n: "02", t: "Insight", d: "We make unconscious patterns and beliefs visible." },
        { n: "03", t: "Transformation", d: "You choose anew — on the level of consciousness, body and relationship." },
        { n: "04", t: "Freedom", d: "You live from your truth — carried by love, not fear." },
      ],
    },
    starthere: {
      overline: "Start Here",
      title: "Begin with the SAT-Test.",
      subtitle:
        "In a few minutes you'll find which rule of life is calling you most right now. We then guide you into the SAT world that fits you.",
      cta: "Start the SAT-Test",
      cta_secondary: "Open the Wheel of Life",
    },
    mentor: {
      overline: "About the founder",
      name: "Nenad Vladovic",
      role: "Mentor · Life Designer · Researcher of Consciousness",
      tagline:
        "I help people understand the rules of life — so relationships succeed, self-confidence grows and true transformation becomes possible.",
      story: [
        "My path didn't begin with answers. It began with questions.",
        "Why do people suffer? Why do the same conflicts repeat? Why do relationships fail although love is there? Why do so many feel empty despite success? And why has nobody taught us the most important rules of life?",
        "On my own journey I experienced how strongly our life is shaped by unconscious patterns, beliefs, fears, wounds and inner conflicts. At the same time I recognised the immense potential each human carries — once they begin to truly understand themselves.",
        "From this insight, SAT — Swiss Academy for Transformation — was born.",
      ],
      mission_title: "My mission",
      mission:
        "To support people in understanding themselves, living more consciously and unfolding their potential. Many problems do not arise because people lack skills — but because they lack the most important rules of life.",
      values_title: "What I stand for",
      values: [
        "Development instead of judgement",
        "Awareness instead of blame",
        "Responsibility instead of victimhood",
        "Compassion instead of separation",
        "Love as the greatest force of transformation",
      ],
      vision_title: "The vision of SAT",
      vision:
        "To build one of the most meaningful platforms for transformation, life competence and consciousness in the German-speaking world — and beyond. A platform that orients, that gives hope, that connects.",
      motto: "LOVE IS TRANSFORMATION",
      motto_sub: "Every real change begins where we find the courage to meet ourselves honestly.",
    },
    themes: {
      overline: "Our topics",
      title: "Nine rooms. One path to yourself.",
      subtitle: "Choose the room that calls you. We will walk into the depth with you.",
      items: [
        { t: "Relationships", d: "Connecting instead of entangling." },
        { t: "Self-worth", d: "Accepting yourself as valuable." },
        { t: "Purpose", d: "Doing what matches your being." },
        { t: "Trauma", d: "Healing what you couldn't choose." },
        { t: "Communication", d: "Saying what you truly mean." },
        { t: "Human Design", d: "Recognising who you are." },
        { t: "Consciousness", d: "Looking behind the reaction." },
        { t: "Family", d: "Heal the roots, strengthen the trunk." },
        { t: "Meaning", d: "Find orientation in the noise." },
      ],
    },
    offerings: {
      overline: "Offerings",
      title: "Guidance at every level.",
      items: [
        { t: "SAT Coaching", d: "1:1 mentoring — online or in person.", price: "On request" },
        { t: "SAT Academy", d: "Guided online courses & modules on the rules of life.", price: "From CHF 49" },
        { t: "Herzbewegung", d: "Community initiative for lived humanity.", price: "Free to join" },
        { t: "Workshops", d: "Intensive group days — Switzerland & DACH.", price: "From CHF 290" },
        { t: "Seminars & Retreats", d: "Multi-day transformation experiences.", price: "From CHF 890" },
        { t: "Books & Audiobooks", d: "The rules of life — in black on white.", price: "From CHF 24" },
      ],
      cta: "Design my program",
    },
    testimonials: {
      overline: "Voices from SAT",
      title: "What people say after taking the first step.",
      items: [
        { q: "The SAT-Unity community helps me stay with my topics. I keep learning and look forward to every exchange.", a: "Sandra Gross", l: "Schwamendingen, CH" },
        { q: "It's beautiful to see that respect is honoured here — that gives a good feeling as a member.", a: "Uwe Tännler", l: "Brienz, CH" },
        { q: "These clear values create a warm atmosphere — a community where one truly feels at home.", a: "Gunnar Kloss", l: "Hamburg, DE" },
        { q: "Nenad helped me see a conflict I had carried for years. Today my life feels wider.", a: "Vanessa B.", l: "Zurich, CH" },
      ],
    },
    community: {
      overline: "Herzbewegung",
      title: "A movement that touches the heart.",
      subtitle:
        "Herzbewegung is the non-profit initiative of SAT. Every day a small gesture that brightens another person's life. From hundreds of gestures a wave is born.",
      points: ["Community challenges", "Good-News stream", "Success stories", "Live events"],
      cta: "Join in",
    },
    ecosystem: {
      overline: "The SAT ecosystem",
      title: "One academy. Many worlds.",
      subtitle: "Choose the world that calls you. Each platform is part of the same mission.",
      items: [
        { k: "akademie", t: "SAT Academy", d: "Main brand · Personal development & consciousness.", tag: "Main" },
        { k: "herzbewegung", t: "Herzbewegung", d: "Community for daily humanity.", tag: "Initiative" },
        { k: "vaterstimme", t: "Vaterstimme", d: "Self-empowerment into dignified fatherhood.", tag: "Men · Fathers" },
        { k: "mutterstimme", t: "Mutterstimme", d: "Self-care, balance & motherhood.", tag: "Women · Mothers" },
        { k: "maennerstimme", t: "Männerstimme", d: "Conscious masculinity & growth.", tag: "Men" },
        { k: "frauenstimme", t: "Frauenstimme", d: "Personal development for women.", tag: "Women" },
        { k: "kinderstimme", t: "Kinderstimme", d: "Children & family development.", tag: "Family" },
        { k: "mentor", t: "SAT Mentor Academy", d: "Become a SAT Mentor, Coach, Trainer, Speaker.", tag: "Certification" },
        { k: "corporate", t: "Corporate Conscious Leadership", d: "Conscious leadership for companies & SMEs.", tag: "Business" },
        { k: "book", t: "SAT BOOK", d: "Books, workbooks, audiobooks, downloads.", tag: "Media" },
        { k: "podcast", t: "SAT Podcast", d: "The rules of life — to listen.", tag: "Audio" },
        { k: "tv", t: "SAT TV", d: "Video learning platform. Library. Documentaries.", tag: "Video" },
        { k: "app", t: "SAT App", d: "Your daily companion — soon in your pocket.", tag: "Mobile" },
        { k: "ai", t: "SAT AI", d: "Conscious AI coach in the SAT spirit — in development.", tag: "Intelligence" },
      ],
      coming: "Coming soon",
    },
    leadmagnet: {
      overline: "Free resources",
      title: "Workbook · 9 Steps to Your Transformation",
      subtitle:
        "Drop your email and receive the free workbook — plus a series of inspiring impulses from the SAT world.",
      placeholder_name: "First name",
      placeholder_email: "Email address",
      cta: "Get the workbook",
      success: "Welcome to the SAT family. Check your inbox.",
      privacy: "We respect your privacy. You may unsubscribe anytime.",
    },
    finalcta: {
      title_l1: "Maybe today",
      title_l2: "is the day",
      title_l3: "your life changes.",
      cta: "Book a free conversation",
      whisper: "LOVE IS TRANSFORMATION",
    },
    contact: {
      title: "Contact us",
      subtitle: "Write to us about what matters to you. We will reply personally.",
      first_name: "First name",
      last_name: "Last name",
      email: "Email",
      phone: "Phone (optional)",
      topic: "Topic",
      topic_options: ["First conversation", "Coaching", "Academy", "Corporate", "Other"],
      message: "Your message",
      send: "Send",
      success: "Thank you! Your message arrived.",
    },
    quiz: {
      title: "Which rule of life is missing for you right now?",
      subtitle: "12 questions · 3 minutes · Personal result by email.",
      start: "Start the test",
      progress: "Question",
      of: "of",
      scale_low: "doesn't fit at all",
      scale_high: "fully true",
      email_step_title: "Your result is ready.",
      email_step_sub: "Leave your email — we'll send the analysis right away.",
      submit: "See result",
      result_kicker: "Your missing rule",
      result_cta: "Book a free conversation",
      another: "Take the test again",
    },
    wheel: {
      title: "Your wheel of life",
      subtitle: "Rate each area from 0 to 10. See where your life flows — and where it stutters.",
      categories: {
        beziehung: "Relationship",
        gesundheit: "Health",
        beruf: "Profession",
        finanzen: "Finances",
        familie: "Family",
        sinn: "Meaning",
        selbstwert: "Self-worth",
        spiritualitaet: "Spirituality",
      },
      save: "Save result",
      avg: "Average",
      weakest: "Your growth area",
    },
    footer: {
      tagline: "Swiss Academy for Transformation",
      motto: "LOVE IS TRANSFORMATION",
      col1: "Academy",
      col2: "Ecosystem",
      col3: "More",
      rights: "All rights reserved.",
      imprint: "Imprint",
      privacy: "Privacy",
      terms: "Terms",
    },
  },
};
